// @ts-nocheck
import './Pylon.css';

import { UserModel } from '@/models/UserModel';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

import { Loadable } from './Loadable';

export class Pylon extends Loadable {
  public static setChatSettings(user: UserModel, backendEmail?: string): void {
    if (!Pylon.isEnabled()) {
      return;
    }

    window.pylon = {
      chat_settings: {
        app_id: import.meta.env.VITE_PYLON_APP_ID,
        email: backendEmail ?? user.email,
        name: user.fullName,
        email_hash: user.email_hash
      }
    };
  }

  public static setNewIssueCustomFields(user: UserModel): void {
    if (!Pylon.isEnabled()) {
      return;
    }

    const customFields = {
      user_id: user.id,
      organization_id: user.organization_details?.id,
      organization_name: user.organization_details?.name,
      facility_id: user.facility_id,
      facility_name: user.user_facility_accesses?.find(
        (f) => f.facility_id === user.facility_id
      )?.facility?.name,
      user_role: user.user_type?.title,
      user_title: user.title
    };
    window.Pylon('setNewIssueCustomFields', customFields);
  }

  public static show(): void {
    if (!Pylon.isEnabled()) {
      return;
    }

    window.Pylon?.('show');
  }

  public static hide(): void {
    if (!Pylon.isEnabled()) {
      return;
    }

    window.Pylon?.('hide');
  }

  public load(): void {
    if (!Pylon.isEnabled()) {
      return;
    }

    (function () {
      var e = window;
      var t = document;
      var n = function () {
        n.e(arguments);
      };
      n.q = [];
      n.e = function (e) {
        n.q.push(e);
      };
      e.Pylon = n;

      var r = function () {
        var e = t.createElement('script');
        e.setAttribute('type', 'text/javascript');
        e.setAttribute('async', 'true');
        e.setAttribute(
          'src',
          `https://widget.usepylon.com/widget/${import.meta.env.VITE_PYLON_APP_ID}`
        );
        var n = t.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(e, n);
      };

      if (t.readyState === 'complete') {
        r();
      } else if (e.addEventListener) {
        e.addEventListener('load', r, false);
      }
    })();
  }

  private static isEnabled(): boolean {
    return FeatureFlagService.isEnabled(ExacareFeature.PYLON);
  }
}
